/** 表单项内容为空时统一兜底值，保持行为一致性 */
export var FORM_EMPTY_CONTENT = '- -';
